import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000';

export default function PaginaInvitacion() {
  const { token }   = useParams();
  const navigate    = useNavigate();
  const [inv,       setInv]       = useState(null);
  const [error,     setError]     = useState('');
  const [cargando,  setCargando]  = useState(true);

  useEffect(() => {
    fetch(`${API}/api/invitaciones/${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.error) setError(data.error);
        else setInv(data);
      })
      .catch(() => setError('No se pudo cargar la invitación'))
      .finally(() => setCargando(false));
  }, [token]);

  const handleRegistrarse = () => {
    // Guardar token en localStorage para canjearlo después del registro
    localStorage.setItem('turival_invitacion_token', token);
    localStorage.setItem('turival_deporte_login', inv.deporte || 'padel');
    navigate('/login');
  };

  const deporteLabel = inv?.deporte === 'tenis' ? 'Tenis' : 'Pádel';
  const deporteIcono = '🎾';

  if (cargando) {
    return (
      <div style={styles.pagina}>
        <div style={styles.card}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.cargando}>Cargando invitación...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.pagina}>
        <div style={styles.card}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.errorIcono}>⚠️</div>
          <div style={styles.errorTitulo}>
            {error === 'Esta invitación ya fue usada'
              ? 'Invitación ya utilizada'
              : error === 'Esta invitación ha expirado'
              ? 'Invitación expirada'
              : 'Invitación no válida'}
          </div>
          <div style={styles.errorSub}>
            {error === 'Esta invitación ya fue usada'
              ? 'Esta invitación ya fue canjeada. Si ya te registraste, entra directo a TuRival.'
              : 'Esta invitación ya no está disponible. Pide a tu compañero que te envíe una nueva.'}
          </div>
          <button style={styles.btnPrincipal} onClick={() => navigate('/login')}>
            Ir a TuRival
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pagina}>
      <div style={styles.card}>
        <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>

        <div style={styles.invIcono}>{deporteIcono}</div>
        <div style={styles.invTitulo}>¡Te invitan a jugar!</div>
        <div style={styles.invSub}>
          Hola <strong>{inv.nombre}</strong>, tienes una invitación para ser pareja en {deporteLabel}.
        </div>

        {/* Card del desafío */}
        <div style={styles.desafioCard}>
          <div style={styles.desafioVs}>
            <div style={styles.desafioEquipo}>{inv.local_nombre}</div>
            <div style={styles.desafioVsLabel}>VS</div>
            <div style={styles.desafioEquipo}>{inv.visitante_nombre}</div>
          </div>
          <div style={styles.desafioMeta}>
            <div style={styles.desafioMetaItem}>📅 {inv.fecha} · {inv.hora}</div>
            {inv.recinto_nombre && (
              <div style={styles.desafioMetaItem}>🏟️ {inv.recinto_nombre}</div>
            )}
            <div style={styles.desafioMetaItem}>{deporteIcono} {deporteLabel}</div>
          </div>
        </div>

        <div style={styles.pasos}>
          <div style={styles.pasoItem}>
            <div style={styles.pasoNum}>1</div>
            <div style={styles.pasoTexto}>Regístrate gratis en TuRival</div>
          </div>
          <div style={styles.pasoItem}>
            <div style={styles.pasoNum}>2</div>
            <div style={styles.pasoTexto}>Quedas vinculado como pareja automáticamente</div>
          </div>
          <div style={styles.pasoItem}>
            <div style={styles.pasoNum}>3</div>
            <div style={styles.pasoTexto}>El desafío se activa y están listos para jugar</div>
          </div>
        </div>

        <button style={styles.btnPrincipal} onClick={handleRegistrarse}>
          ⚡ Registrarme y unirme
        </button>

        <div style={styles.expira}>
          Esta invitación expira en 48 horas
        </div>
      </div>
    </div>
  );
}

const styles = {
  pagina: {
    minHeight: '100vh', background: '#0D1117',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  },
  card: {
    background: '#161C26', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20, padding: 36, width: '100%', maxWidth: 420,
    textAlign: 'center',
  },
  logo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 20,
  },
  naranja: { color: '#FF6B1A' },
  cargando: { color: 'rgba(255,255,255,0.4)', fontSize: 14, fontFamily: "'Barlow', sans-serif" },
  errorIcono: { fontSize: 48, marginBottom: 12 },
  errorTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: 'white', marginBottom: 8,
  },
  errorSub: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.6,
  },
  invIcono: { fontSize: 48, marginBottom: 12 },
  invTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: 'white', marginBottom: 8,
  },
  invSub: {
    fontSize: 13, color: 'rgba(255,255,255,0.5)',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.6,
  },
  desafioCard: {
    background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 14, padding: '16px 20px', marginBottom: 20,
  },
  desafioVs: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: 12, marginBottom: 12,
  },
  desafioEquipo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, color: 'white', flex: 1, textAlign: 'center',
  },
  desafioVsLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 700, color: '#FF6B1A',
  },
  desafioMeta: {
    display: 'flex', flexDirection: 'column', gap: 4,
    borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 10,
  },
  desafioMetaItem: {
    fontSize: 12, color: 'rgba(255,255,255,0.5)',
    fontFamily: "'Barlow', sans-serif",
  },
  pasos: {
    display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24, textAlign: 'left',
  },
  pasoItem: {
    display: 'flex', alignItems: 'center', gap: 12,
  },
  pasoNum: {
    width: 24, height: 24, borderRadius: '50%',
    background: '#FF6B1A', color: 'white',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 12, fontWeight: 800, flexShrink: 0,
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  pasoTexto: {
    fontSize: 13, color: 'rgba(255,255,255,0.6)',
    fontFamily: "'Barlow', sans-serif", lineHeight: 1.4,
  },
  btnPrincipal: {
    width: '100%', padding: '14px', background: '#FF6B1A', border: 'none',
    borderRadius: 12, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white', marginBottom: 12,
  },
  expira: {
    fontSize: 11, color: 'rgba(255,255,255,0.25)',
    fontFamily: "'Barlow', sans-serif", fontStyle: 'italic',
  },
};
